import { render } from "./ExchangeView.vue?vue&type=template&id=1cddec0e&scoped=true&ts=true"
import script from "./ExchangeView.vue?vue&type=script&lang=ts"
export * from "./ExchangeView.vue?vue&type=script&lang=ts"

import "./ExchangeView.vue?vue&type=style&index=0&id=1cddec0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cddec0e"]])

export default __exports__